// import { ref, onMounted, onUnmounted } from 'vue'
import api from "@/api";
import { email as veeEmailValidation } from "@vee-validate/rules";
import { property, filter, isNil, debounce } from "lodash";

// service-profile risponde 400 sia quando la P.IVA è già presente
// (PROFILE-00095) sia quando isValidVAT la rifiuta o il servizio VIES non
// risponde (COMMONS-00005, solo in produzione). Solo il primo caso è un
// "già registrata": tutto il resto è un'anomalia da segnalare come tale.
const VAT_ALREADY_REGISTERED = "PROFILE-00095";

const VAT_MESSAGES = {
  alreadyRegistered: "Questa P.IVA è già registrata",
  anomaly: "Rilevata anomalia con la Partita IVA inserita",
};

function validateVat(vat, excluding = null) {
  return api.validation.organizationValidationVAT({ vat, excluding })
}

function vatErrorMessage(error) {
  return error?.response?.data?.error === VAT_ALREADY_REGISTERED
    ? VAT_MESSAGES.alreadyRegistered
    : VAT_MESSAGES.anomaly;
}

function validateEmail(email, exluding) {
  if (!veeEmailValidation(email)) {
    return Promise.reject(new Error('Email not valid'))
  }
  return api.validation.userUniqueEmail(
    {
      value: email,
      excluding: exluding,
    })
}


function fetchInvitationData(email) {
  if (!veeEmailValidation(email)) {
    return Promise.reject(new Error('Email not valid'))
  }
  return api.landingcontact.getFromEmail(email);
}

import { isValidPhoneNumber } from 'libphonenumber-js';

// Solo controllo di formato: usato dove il numero non deve essere univoco
// per utente (es. il telefono aziendale, che può coincidere con quello personale)
function validatePhoneFormat(phone) {
  // Use robust library validation for international support
  if (!isValidPhoneNumber(phone)) {
    return Promise.reject(new Error('Phone not valid'));
  }
  return Promise.resolve();
}

function validatePhone(phone, excluding) {
  // Use robust library validation for international support
  if (!isValidPhoneNumber(phone)) {
    return Promise.reject(new Error('Phone not valid'));
  }

  // If valid format, proceed to backend validation (e.g. uniqueness)
  return api.validation.userUniquePhone({
    value: phone,
    excluding: excluding,
  });
}


function checkMandatoryAgreement(list, acceptedAgreements) {
  return list
    .filter(property("isMandatory"))
    .map(property("id"))
    .every((id) => acceptedAgreements.includes(id));
}

export const useRegisterFormTools = {
  validatePhone,
  validatePhoneFormat,
  validateEmail,
  validateVat,
  vatErrorMessage,
  checkMandatoryAgreement,
  fetchInvitationData
}
